var map = {
	"./android-icon.png": 32,
	"./angular-icon.png": 33,
	"./car-icon.png": 34,
	"./certificadoIBMModeladoDeSistemasConRational.png": 12,
	"./certificate-icon.png": 2,
	"./check-list-icon.png": 11,
	"./close-icon.png": 9,
	"./coffee-icon.png": 35,
	"./crossfit-icon.png": 36,
	"./css-icon.png": 37,
	"./dark-mode-car-icon.png": 38,
	"./dark-mode-certificate-icon.png": 3,
	"./dark-mode-check-list-icon.png": 10,
	"./dark-mode-close-icon.png": 8,
	"./dark-mode-coffee-icon.png": 39,
	"./dark-mode-crossfit-icon.png": 40,
	"./dark-mode-design-icon.png": 41,
	"./dark-mode-element47-icon.png": 42,
	"./dark-mode-github-icon.png": 13,
	"./dark-mode-more-info-icon.png": 14,
	"./dark-mode-photography-icon.png": 43,
	"./dark-mode-repository-code-icon.png": 15,
	"./dark-mode-ski-icon.png": 44,
	"./dark-mode-www-icon.png": 16,
	"./design-icon.png": 45,
	"./download-resume-pdf-icon.png": 17,
	"./element47-icon.png": 46,
	"./github-icon.png": 47,
	"./java-fx-icon.png": 48,
	"./java-icon.png": 49,
	"./js-icon.png": 50,
	"./linkedIn-icon.png": 18,
	"./mail-icon.png": 19,
	"./more-info-icon.png": 20,
	"./ngrx.svg": 51,
	"./photography-icon.png": 52,
	"./profile-picture.jpg": 7,
	"./react-icon.png": 53,
	"./redesign-web-bac-mono.png": 54,
	"./reemplazo-de-smartphones.png": 55,
	"./repository-code-icon.png": 21,
	"./rxjs.svg": 56,
	"./sass.svg": 57,
	"./ski-icon.png": 58,
	"./typescript.png": 59,
	"./vsco-icon.png": 22,
	"./vue-icon.png": 60,
	"./www-icon.png": 23
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5;